// Seed images removed  -  ORACLE starts empty, orb shows neural-net sphere
export const SEED_IMGS = [];

export const LAUNCHED_KEY = "oracle_launched";

export const ORB_SIZE = 320;
export const CX = 160;
export const CY = 160;
export const ORB_R = 150;

export const G = `
@import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@300;400;500&family=DM+Sans:wght@300;400;500&family=Bebas+Neue&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
@keyframes orb-breathe{0%,100%{box-shadow:0 0 45px 12px rgba(255,255,255,.08),0 0 90px 25px rgba(255,255,255,.04),0 0 0 1px rgba(255,255,255,.1)}50%{box-shadow:0 0 65px 20px rgba(255,255,255,.14),0 0 130px 40px rgba(255,255,255,.07),0 0 0 1px rgba(255,255,255,.18)}}
@keyframes burst-out{0%{transform:scale(1);opacity:1}60%{transform:scale(14);opacity:.15}100%{transform:scale(28);opacity:0}}
@keyframes grid-reveal{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
@keyframes fade-in{from{opacity:0}to{opacity:1}}
@keyframes slide-up{from{transform:translateY(100%);opacity:0}to{transform:translateY(0);opacity:1}}
@keyframes panel-in{from{opacity:0;transform:scale(.95) translateY(10px)}to{opacity:1;transform:scale(1) translateY(0)}}
@keyframes spin{to{transform:rotate(360deg)}}
@keyframes pop{from{transform:scale(.85);opacity:0}to{transform:scale(1);opacity:1}}
@keyframes pulse{0%,100%{opacity:.5}50%{opacity:1}}
@keyframes shimmer{0%{background-position:-200% 0}100%{background-position:200% 0}}
::-webkit-scrollbar{width:3px}
::-webkit-scrollbar-track{background:#070710}
::-webkit-scrollbar-thumb{background:rgba(255,255,255,.07);border-radius:4px}
html,body{-webkit-text-size-adjust:100%;touch-action:manipulation}
input,textarea,select{font-size:16px!important}
@media(max-width:640px){
  .oracle-grid{grid-template-columns:1fr 1fr!important}
  .oracle-header-actions{gap:4px!important}
  .oracle-search-row{flex-wrap:wrap!important}
}
input.mb-dim{ -moz-appearance:textfield; font-size:11px!important; }
input.mb-dim::-webkit-outer-spin-button, input.mb-dim::-webkit-inner-spin-button{ -webkit-appearance:none; margin:0; }
`;

